import { useRef } from "react"
import { useInView } from "framer-motion"
import styled from "@emotion/styled"

import Video, { cssControls } from "components/media/VideoCLD"

import { useConsole } from "contexts/Console"

import { columnWidth } from "css/columnWidth"
import { fullGrid } from "css/grid"

import generateBackground from "utils/generateBackground"

import FigCaption from "components/figcaption/FigCaption"

const Root = styled.section`
  ${fullGrid}
`
const Wrapper = styled.figure`
  --transition: 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.1s;
  ${columnWidth}
  clip-path: ${({ isInView, animate }) => animate && (isInView ? "inset(0%)" : "inset(10%)")};
  grid-row: vid;
  transition: clip-path var(--transition);
  will-change: clip-path;

  .${cssControls} {
    inset: ${({ isInView, animate }) => animate && (isInView ? "0" : "-10%")};
    position: relative;
    transform: translateZ(0);
    transition: inset var(--transition);
  }
`

export default function VideoAutoplay({ className, width, video_cld: video, background, noButton, animation, forceStop, fig_caption }) {
  const console = useConsole()
  const rvideo = useRef()
  const rwrapper = useRef()
  // const prefersReducedMotion = useReducedMotion()
  const animate = animation === "mask"

  const isInView = useInView(rwrapper)

  const cssStyle = background ? generateBackground(background) : {}

  const imageSizes =
    {
      l: "84vw, (min-width: 48rem) 80vw",
      m: "84vw, (min-width: 48rem) 70vw",
      s: "84vw, (min-width: 48rem) 50vw",
    }[width] || "100vw"

  console.verbose("VideoAutoplay(%o)", { node: rvideo.current?.node })
  return (
    <Root className={className} style={cssStyle}>
      <Wrapper ref={rwrapper} className={`width-${!width ? "xl" : width} dark-theme`} isInView={isInView} animate={animate}>
        <Video ref={rvideo} noButton={noButton} autoPlay {...video} className={!!animation && "animate"} sizes={imageSizes} forceStop={forceStop} />
        {fig_caption?.caption?.length ? <FigCaption {...fig_caption} /> : null}
      </Wrapper>
    </Root>
  )
}
